export default __webpack_public_path__ + "static/1814-f86fdbb47b4f5687a960c2045d13cc35.jpeg";